import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

export const getAdtMessage = async (filename) => {
  const url = interpolate(endpoints.adt.downloadAdt, {
    filename,
  });
  const response = await api.get(url);
  return response;
};
